<template>
  <nav class="product-list-filter">
    <button
      class="btn toggle-btn"
      @click="activateFilters">
      Categories
    </button>

    <div class="filter-options">
      <button
        class="btn is-dark"
        v-for="category in categories"
        @click="scrollToSection(category)"
        :key="category">
        {{category}}
      </button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'product-list-filter',

  props: {
    categories: Array
  },

  methods: {
    scrollToSection(category) {
      let el = category.toLowerCase()
      document.getElementById(`product-category-${el}`).scrollIntoView({
        behavior: 'smooth'
      })

      this.$emit('activateFilters', 'filters')
    },

    activateFilters() {
      this.$emit('activateFilters', 'filters')
    }
  }
}
</script>

<style lang="sass">
  @import '../../../stylesheets/base/variables'
  @import '../../../stylesheets/helpers/mixins'
  @import '../../../stylesheets/helpers/extends'

  .product-list-filter
    max-height: 34px
    transition: all .3s ease-in-out
    overflow: hidden

    .filter-options
      padding: $gap-medium
      display: flex
      align-items: center
      justify-content: center
      flex-wrap: wrap

      button
        border: 1px solid #00000012
        padding: $gap-small
        margin: $gap-small
        border-radius: 5px

    .toggle-btn
      background: #989898 !important
      border-top: 1px solid #00000012

    .btn
      box-shadow: 0 0 10px #00000030
</style>
